/**
 * In this file, we create a React component
 * which incorporates components provided by Material-UI.
 */
import React, { useEffect } from 'react';
import queryString from 'query-string';
import { Container, Row, Col } from 'reactstrap';

import RequestLoginErrorMessage from '../../components/RequestLoginErrorMessage';
import ServiceApi from '../../services/ServiceApi';

import './style.scss';
import LoginForm from './LoginForm';

const Login = ({ location, translate }) => {
  useEffect(() => {
    document.title = 'Login - Zapping';
    document.body.style.backgroundColor = '#16181C';
  });
  const api = new ServiceApi();
  const parameters = queryString.parse(location.search);
  const _validateParams = () => {
    if (!parameters.client_id || !parameters.redirect_uri || !parameters.response_type)
      return false;
    return true;
  }

  return (
    <Container fluid={true} className="zap-body">
      <Row>
        <Col>
          {
            _validateParams()
              ? <LoginForm
                api={api}
                location={location}
              />
              : <RequestLoginErrorMessage
                onlyMessage={true}
                message={translate('RequestLoginErrorMessage')}
              />
          }
        </Col>
      </Row>
    </Container>
  );
}

export default Login;
